export const licenseTranslations = {
  ar: {
    title: 'التراخيص',
    addNew: 'إضافة ترخيص جديد',
    licenseKey: 'مفتاح الترخيص',
    daysCount: 'عدد الأيام',
    startDate: 'تاريخ البدء',
    expiryDate: 'تاريخ الانتهاء',
    isActive: 'نشط',
    isExpired: 'منتهي',
    companyName: 'اسم الشركة',
    contactEmail: 'البريد الإلكتروني',
    contactPhone: 'رقم الهاتف',
    notes: 'ملاحظات',
    remainingDays: 'الأيام المتبقية',
    isValid: 'صالح',
    actions: 'الإجراءات',
    edit: 'تعديل',
    extend: 'تمديد',
    delete: 'حذف',
    extendDays: 'عدد أيام التمديد',
    createSuccess: 'تم إنشاء الترخيص بنجاح',
    createError: 'فشل إنشاء الترخيص',
    updateSuccess: 'تم تحديث الترخيص بنجاح',
    updateError: 'فشل تحديث الترخيص',
    extendSuccess: 'تم تمديد الترخيص بنجاح لمدة {days} يوم',
    extendError: 'فشل تمديد الترخيص',
    deleteSuccess: 'تم حذف الترخيص بنجاح',
    deleteError: 'فشل حذف الترخيص',
    updateExpiredSuccess: 'تم تحديث التراخيص المنتهية',
    updateExpiredError: 'فشل تحديث التراخيص المنتهية',
    confirmDelete: 'هل أنت متأكد من حذف هذا الترخيص؟',
    saving: 'جاري الحفظ...',
    save: 'حفظ',
    extending: 'جاري التمديد...',
    pageTitle: 'إدارة التراخيص',
    pageDescription: 'إدارة تراخيص النظام وعدد الأيام',
    licenseStatus: 'حالة الترخيص',
    warning: 'تحذير',
    active: 'نشط',
    expired: 'منتهي',
    remaining: 'متبقي',
    days: 'يوم',
    renewSoon: 'يرجى التجديد قريباً',
    expiresOn: 'ينتهي في:',
    createNewLicense: 'يرجى إنشاء ترخيص جديد',
    updateExpired: 'تحديث المنتهية',
    saveToNotion: 'حفظ في Notion',
    savingToNotion: 'جاري الحفظ...',
    saveToNotionTitle: 'حفظ التراخيص في Notion',
    saveToNotionMessage: 'هل تريد حفظ جميع التراخيص من قاعدة البيانات في Notion؟',
    licenseName: 'اسم الترخيص',
    approvalStatus: 'حالة الموافقة',
    status: 'الحالة',
    approved: 'موافق عليه',
    rejected: 'مرفوض',
    pending: 'في الانتظار',
    developerMode: 'وضع المطور مفعّل',
    addNewLicense: 'إضافة ترخيص جديد',
    newLicenseTitle: 'إضافة ترخيص جديد',
    editLicense: 'تعديل الترخيص',
    extendLicense: 'تمديد الترخيص',
    autoGenerated: 'سيتم توليده تلقائياً',
    deviceId: 'معرف الجهاز',
    hardDiskId: 'معرف الهارد ديسك',
    encrypted: '(مشفر)',
    optional: '(اختياري)',
    required: '*',
    cannotEditAfterApproval: '(لا يمكن التعديل بعد الموافقة)',
    standardDuration: 'المدة القياسية: 365 يوم (سنة كاملة)',
    defaultDays: 'عدد أيام السنة',
    additionalDays: 'عدد الأيام الإضافية',
    currentLicense: 'الترخيص الحالي:',
    willRecalculate: 'سيتم إعادة حساب تاريخ الانتهاء من تاريخ البدء الأصلي +',
    cancel: 'إلغاء',
    saveAndSend: 'حفظ وإرسال إلى Notion',
    warningApproved: 'هذا الترخيص موافق عليه. يمكنك تعديل بعض الحقول فقط.',
    updateFromNotion: 'تحديث الترخيص من Notion',
    updateFromNotionMessage: 'هل تريد تحديث الترخيص من Notion؟ سيتم جلب الترخيص من Notion وفك تشفير البيانات المشفرة لاستخراج HardDiskId والتواريخ وحالة الموافقة (Approved/Rejected).',
    enterHardDiskId: 'أدخل معرف الهارد ديسك للترخيص',
    willMergeAndEncrypt: 'سيتم دمج معرف الهارد ديسك مع تاريخ البدء والانتهاء وتشفيرها',
    currentLicenseDays: 'عدد الأيام:',
    currentExpiryDate: 'تاريخ الانتهاء:',
    willRecalculateFromStart: 'سيتم إعادة حساب تاريخ الانتهاء من تاريخ البدء الأصلي +',
  },
  en: {
    title: 'Licenses',
    addNew: 'Add New License',
    licenseKey: 'License Key',
    daysCount: 'Days Count',
    startDate: 'Start Date',
    expiryDate: 'Expiry Date',
    isActive: 'Active',
    isExpired: 'Expired',
    companyName: 'Company Name',
    contactEmail: 'Contact Email',
    contactPhone: 'Contact Phone',
    notes: 'Notes',
    remainingDays: 'Remaining Days',
    isValid: 'Valid',
    actions: 'Actions',
    edit: 'Edit',
    extend: 'Extend',
    delete: 'Delete',
    extendDays: 'Extension Days',
    createSuccess: 'License created successfully',
    createError: 'Failed to create license',
    updateSuccess: 'License updated successfully',
    updateError: 'Failed to update license',
    extendSuccess: 'License extended successfully for {days} days',
    extendError: 'Failed to extend license',
    deleteSuccess: 'License deleted successfully',
    deleteError: 'Failed to delete license',
    updateExpiredSuccess: 'Expired licenses updated',
    updateExpiredError: 'Failed to update expired licenses',
    confirmDelete: 'Are you sure you want to delete this license?',
    saving: 'Saving...',
    save: 'Save',
    extending: 'Extending...',
    pageTitle: 'License Management',
    pageDescription: 'Manage system licenses and days count',
    licenseStatus: 'License Status',
    warning: 'Warning',
    active: 'Active',
    expired: 'Expired',
    remaining: 'Remaining',
    days: 'days',
    renewSoon: 'Please renew soon',
    expiresOn: 'Expires on:',
    createNewLicense: 'Please create a new license',
    updateExpired: 'Update Expired',
    saveToNotion: 'Save to Notion',
    savingToNotion: 'Saving...',
    saveToNotionTitle: 'Save Licenses to Notion',
    saveToNotionMessage: 'Do you want to save all licenses from the database to Notion?',
    licenseName: 'License Name',
    approvalStatus: 'Approval Status',
    status: 'Status',
    approved: 'Approved',
    rejected: 'Rejected',
    pending: 'Pending',
    developerMode: 'Developer Mode Enabled',
    addNewLicense: 'Add New License',
    newLicenseTitle: 'Add New License',
    editLicense: 'Edit License',
    extendLicense: 'Extend License',
    autoGenerated: 'Will be auto-generated',
    deviceId: 'Device ID',
    hardDiskId: 'Hard Disk ID',
    encrypted: '(Encrypted)',
    optional: '(Optional)',
    required: '*',
    cannotEditAfterApproval: '(Cannot edit after approval)',
    standardDuration: 'Standard duration: 365 days (full year)',
    defaultDays: 'Number of days in a year',
    additionalDays: 'Additional Days',
    currentLicense: 'Current License:',
    willRecalculate: 'Expiry date will be recalculated from original start date +',
    cancel: 'Cancel',
    saveAndSend: 'Save and Send to Notion',
    warningApproved: 'This license is approved. You can only edit some fields.',
    updateFromNotion: 'Update License from Notion',
    updateFromNotionMessage: 'Do you want to update the license from Notion? The license will be fetched from Notion and encrypted data will be decrypted to extract HardDiskId, dates, and approval status (Approved/Rejected).',
    enterHardDiskId: 'Enter hard disk ID for the license',
    willMergeAndEncrypt: 'Hard disk ID will be merged with start and expiry dates and encrypted',
    currentLicenseDays: 'Days Count:',
    currentExpiryDate: 'Expiry Date:',
    willRecalculateFromStart: 'Expiry date will be recalculated from original start date +',
  },
  fr: {
    title: 'Licences',
    addNew: 'Ajouter une nouvelle licence',
    licenseKey: 'Clé de licence',
    daysCount: 'Nombre de jours',
    startDate: 'Date de début',
    expiryDate: 'Date d\'expiration',
    isActive: 'Actif',
    isExpired: 'Expiré',
    companyName: 'Nom de l\'entreprise',
    contactEmail: 'Email de contact',
    contactPhone: 'Téléphone de contact',
    notes: 'Notes',
    remainingDays: 'Jours restants',
    isValid: 'Valide',
    actions: 'Actions',
    edit: 'Modifier',
    extend: 'Prolonger',
    delete: 'Supprimer',
    extendDays: 'Jours de prolongation',
    createSuccess: 'Licence créée avec succès',
    createError: 'Échec de la création de la licence',
    updateSuccess: 'Licence mise à jour avec succès',
    updateError: 'Échec de la mise à jour de la licence',
    extendSuccess: 'Licence prolongée avec succès pour {days} jours',
    extendError: 'Échec de la prolongation de la licence',
    deleteSuccess: 'Licence supprimée avec succès',
    deleteError: 'Échec de la suppression de la licence',
    updateExpiredSuccess: 'Licences expirées mises à jour',
    updateExpiredError: 'Échec de la mise à jour des licences expirées',
    confirmDelete: 'Êtes-vous sûr de vouloir supprimer cette licence?',
    saving: 'Enregistrement...',
    save: 'Enregistrer',
    extending: 'Prolongation...',
    pageTitle: 'Gestion des licences',
    pageDescription: 'Gérer les licences système et le nombre de jours',
    licenseStatus: 'Statut de la licence',
    warning: 'Avertissement',
    active: 'Actif',
    expired: 'Expiré',
    remaining: 'Restant',
    days: 'jours',
    renewSoon: 'Veuillez renouveler bientôt',
    expiresOn: 'Expire le:',
    createNewLicense: 'Veuillez créer une nouvelle licence',
    updateExpired: 'Mettre à jour les expirées',
    saveToNotion: 'Enregistrer dans Notion',
    savingToNotion: 'Enregistrement...',
    saveToNotionTitle: 'Enregistrer les licences dans Notion',
    saveToNotionMessage: 'Voulez-vous enregistrer toutes les licences de la base de données dans Notion?',
    licenseName: 'Nom de la licence',
    approvalStatus: 'Statut d\'approbation',
    status: 'Statut',
    approved: 'Approuvé',
    rejected: 'Rejeté',
    pending: 'En attente',
    developerMode: 'Mode développeur activé',
    addNewLicense: 'Ajouter une nouvelle licence',
    newLicenseTitle: 'Ajouter une nouvelle licence',
    editLicense: 'Modifier la licence',
    extendLicense: 'Prolonger la licence',
    autoGenerated: 'Sera généré automatiquement',
    deviceId: 'ID de l\'appareil',
    hardDiskId: 'ID du disque dur',
    encrypted: '(Chiffré)',
    optional: '(Optionnel)',
    required: '*',
    cannotEditAfterApproval: '(Impossible de modifier après approbation)',
    standardDuration: 'Durée standard: 365 jours (année complète)',
    defaultDays: 'Nombre de jours dans une année',
    additionalDays: 'Jours supplémentaires',
    currentLicense: 'Licence actuelle:',
    willRecalculate: 'La date d\'expiration sera recalculée à partir de la date de début originale +',
    cancel: 'Annuler',
    saveAndSend: 'Enregistrer et envoyer à Notion',
    warningApproved: 'Cette licence est approuvée. Vous ne pouvez modifier que certains champs.',
    updateFromNotion: 'Mettre à jour la licence depuis Notion',
    updateFromNotionMessage: 'Voulez-vous mettre à jour la licence depuis Notion? La licence sera récupérée depuis Notion et les données chiffrées seront déchiffrées pour extraire HardDiskId, les dates et le statut d\'approbation (Approuvé/Rejeté).',
    enterHardDiskId: 'Entrez l\'ID du disque dur pour la licence',
    willMergeAndEncrypt: 'L\'ID du disque dur sera fusionné avec les dates de début et d\'expiration et chiffré',
    currentLicenseDays: 'Nombre de jours:',
    currentExpiryDate: 'Date d\'expiration:',
    willRecalculateFromStart: 'La date d\'expiration sera recalculée à partir de la date de début originale +',
  },
}

